<template>
	<div class="vx-row" v-if="isForm">
		<div class="vx-col w-full md-2 mt-2 mb-2">
          <vs-switch v-model="value"/>
		</div>
	</div>
	<vs-col vs-justify="center" vs-align="center" vs-w="colw" v-else>
		<div class="vx-row md:mt-2 lg:mt-2">
			<vs-col class="sm:w-full md:w-11/12 lg:w-11/12">
				<vs-input
					:disabled="disabled"
					@keypress="num($event)"
					class="w-full"
					v-model="value"
					:danger="danger"
					:danger-text="dangerText"
				/>
			</vs-col>
		</div>
	</vs-col>
</template>

<script>
import VueFormGenerator from "vue-form-generator";

export default {
	data() {
		return {
      danger: false,
			dangerText: '',
			isForm: true,
			colw: 6
        };
	},
	methods: {},
	mounted() {
		if (
			typeof this.schema.cols !== undefined &&
			this.schema.cols == true
		) {
			this.isForm = false;
		}
	},
	mixins: [VueFormGenerator.abstractField]
};
</script>
